import React from 'react';
import Styled from 'styled';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import like2 from 'four-nets/icons/svg/icon_like-2.svg';
import like from 'four-nets/icons/svg/icon_like.svg';

import LikersDialog from './post-likers-dialog/post-likers-dialog';

import Button from '../button/button';
import defaultStyles from './post-likers-button.scss';

export interface Props {
    styles: typeof defaultStyles;
    likesCount: number;
    id: string;
}

interface State {
    open: boolean;
}

class Likers extends React.PureComponent<Props, State> {
    state = {
        open: false,
    };

    close = () => {
        this.setState({ open: false });
    };

    open = () => {
        this.setState({ open: true });
    };

    render() {
        const { styles, likesCount, id } = this.props;

        return likesCount ? (
            <React.Fragment>
                <LikersDialog id={id} open={this.state.open} onClose={this.close} />
                <Button
                    style={{ button: styles.button }}
                    onClick={this.open}
                    disabled={!likesCount || likesCount === 0}
                >
                    <span className={styles!.likeCount}>
                        <SVGIcon style={{ image: styles.icon }} src={!likesCount || likesCount === 0 ? like : like2} />
                        {likesCount}
                    </span>
                </Button>
            </React.Fragment>
        ) : null;
    }
}

export default Styled(defaultStyles)(Likers);
